import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
import { Button } from './components/Button';
// Meta Pixel Types
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const FadeIn = ({
  children,
  delay = 0
}: {
  children: React.ReactNode;
  delay?: number;
}) => <motion.div initial={{
  opacity: 0,
  y: 20
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-50px'
}} transition={{
  duration: 0.5,
  delay
}} data-id="element-0">
    {children}
  </motion.div>;
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel
    if (typeof window !== 'undefined' && !window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        document.head.appendChild(t);
      }
      window.fbq('init', '790333870788238');
      window.fbq('track', 'PageView');
    }
  }, []);
  const scrollToCompra = () => {
    const element = document.getElementById('compra');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-white font-sans text-brand-navy selection:bg-brand-pink selection:text-white pb-20" data-id="element-1">
      {/* TOP ANNOUNCEMENT BAR */}
      <div className="bg-brand-red text-white text-center py-2 px-4 text-sm font-medium w-full" data-id="element-2">
        🔥 Planificacion Anual Primaria y Secundaria + 1000 actividades
      </div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 pt-4" data-id="element-3">
        {/* 1. HERO SECTION */}
        <section className="text-center mb-12" data-id="element-4">
          <FadeIn data-id="element-5">
            <p className="text-brand-gray sm:text-base mb-2 font-medium text-[12px]" data-id="element-6">
              "Material educativo para docentes de ingles"
            </p>
            <h1 className="sm:text-4xl md:text-5xl font-black text-brand-pink mb-4 text-[24px]" data-id="element-7">
              MEGAPACK TEACHER'S RESOURCE
            </h1>
            <h2 className="sm:text-2xl font-bold text-brand-navy mb-8 text-[18px]" data-id="element-8">
              Dejá de perder horas buscando actividades de inglés
            </h2>

            <div className="relative max-w-md mx-auto mb-8" data-id="element-9">
              <img src="https://cdn.magicpatterns.com/uploads/3tbKDwRBGRNVqvV5isiD6n/Diseno_sin_titulo.png" alt="Megapack Teacher's Resource" className="w-full" data-id="element-10" />
            </div>

            <p className="text-base sm:text-lg text-brand-navy mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-11">
              Todo el material organizado, listo para usar y adaptado a cada
              nivel
            </p>

            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto mb-10 text-left" data-id="element-12">
              <h3 className="font-bold text-lg sm:text-xl mb-6 text-center text-brand-navy" data-id="element-13">
                👉 Acceso inmediato y organizado
              </h3>
              <ul className="space-y-4" data-id="element-14">
                {['Comprás ahora', 'Recibís acceso automático', 'Entrás al material organizado por niveles', 'Podés descargar o usar directamente'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-bold text-base sm:text-lg" data-id="element-15">
                    <span className="mr-3 text-xl text-green-500" data-id="element-16">✔</span>
                    {item}
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </section>

        {/* 2. PREGUNTA BLOCK */}
        <section className="text-center mb-12" data-id="element-17">
          <FadeIn data-id="element-18">
            <p className="text-lg mb-4 font-[600] text-[#E91E8E]" data-id="element-19">
              Si sos docente de inglés, dejame hacerte una pregunta honesta:
            </p>
            <h2 className="sm:text-3xl font-bold mb-6 text-[20px] text-[#E53E3E]" data-id="element-20">
              ¿Sentís que preparar clases te roba demasiado tiempo… todos los
              días?
            </h2>
            <div className="space-y-4 text-base sm:text-lg text-brand-navy max-w-2xl mx-auto" data-id="element-21">
              <p data-id="element-22">
                Es porque cada clase te obliga a volver a buscar actividades,
                pensar dinámicas y preparar todo otra vez.
              </p>
              <p data-id="element-23">
                Y entre clases, correcciones y planificación… terminás dedicando
                horas a algo que podría resolverse mucho más rápido.
              </p>
              <p className="font-bold text-xl mt-6" data-id="element-24">
                Dar clases dinámicas no debería ser tan difícil.
              </p>
            </div>
          </FadeIn>
        </section>

        {/* 3. PROBLEMA BLOCK */}
        <section className="text-center mb-12" data-id="element-25">
          <FadeIn data-id="element-26">
            <h2 className="text-2xl sm:text-3xl font-bold mb-8 text-[#E91E8E]" data-id="element-27">
              El problema que muchos docentes viven todos los días:
            </h2>

            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto mb-8 text-left" data-id="element-28">
              <ul className="space-y-4" data-id="element-29">
                {['Pasás horas buscando actividades en Internet', 'Probás cosas que no funcionan', 'Improvisás clases a último momento', 'Terminás repitiendo siempre lo mismo'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium text-base sm:text-lg" data-id="element-30">
                    <span className="mr-3 text-brand-red font-bold text-xl" data-id="element-31">
                      •
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>

            <p className="text-xl sm:text-2xl font-bold text-brand-navy" data-id="element-32">
              Podrías dar mejores clases… si tuvieras todo listo
            </p>
          </FadeIn>
        </section>

        {/* 4. SOLUCIÓN BLOCK */}
        <section className="text-center mb-12" data-id="element-33">
          <FadeIn data-id="element-34">
            <h2 className="text-2xl sm:text-3xl font-bold text-brand-pink mb-6" data-id="element-35">
              La solución: Megapack Teacher's Resource
            </h2>

            <div className="max-w-xs mx-auto mb-8" data-id="element-36">
              <img src="https://cdn.magicpatterns.com/uploads/of2MgfaMbKCui6PujX43tA/d056731b-fdf6-4a44-99a4-79b8c71923fe.png" alt="Megapack Teacher's Resource" className="w-full" data-id="element-37" />
            </div>

            <p className="text-base sm:text-lg text-brand-navy mb-10 max-w-2xl mx-auto" data-id="element-38">
              Un sistema completo para que dejes de improvisar y entres al aula
              con todo resuelto
            </p>

            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-2xl mx-auto mb-10" data-id="element-39">
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-lg font-bold text-brand-navy" data-id="element-40">
                <div className="flex items-center" data-id="element-41">
                  <span className="text-2xl mr-2" data-id="element-42">📂</span> Elegís el tema
                </div>
                <span className="hidden sm:inline text-brand-gray" data-id="element-43">➔</span>
                <span className="sm:hidden text-brand-gray" data-id="element-44">⬇</span>
                <div className="flex items-center" data-id="element-45">
                  <span className="text-2xl mr-2" data-id="element-46">📖</span> Usás la actividad
                </div>
                <span className="hidden sm:inline text-brand-gray" data-id="element-47">➔</span>
                <span className="sm:hidden text-brand-gray" data-id="element-48">⬇</span>
                <div className="flex items-center text-brand-pink" data-id="element-49">
                  <span className="text-2xl mr-2" data-id="element-50">🗣</span> Aplicás la clase
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-8 mb-10 font-bold text-brand-navy text-lg" data-id="element-51">
              <div className="font-[400]" data-id="element-52">
                <span className="text-green-500" data-id="element-53">✔</span>Sin perder tiempo
              </div>
              <div className="font-[400]" data-id="element-54">
                <span className="text-green-500" data-id="element-55">✔</span>Sin empezar desde cero
              </div>
              <div className="font-[400]" data-id="element-56">
                <span className="text-green-500" data-id="element-57">✔</span>Sin improvisar
              </div>
            </div>

            <div className="max-w-md mx-auto mb-10" data-id="element-58"></div>
          </FadeIn>
        </section>

        {/* 5. CONTENIDO BLOCK */}
        <section className="text-center mb-12" data-id="element-59">
          <FadeIn data-id="element-60">
            <h2 className="text-2xl sm:text-3xl font-bold text-brand-navy mb-10" data-id="element-61">
              ¿Qué incluye el Megapack Teacher's Resource?
            </h2>

            <div className="bg-brand-pink rounded-2xl p-6 sm:p-8 max-w-xl mx-auto mb-10 text-center" data-id="element-62">
              <h3 className="text-xl sm:text-2xl font-black text-white mb-2" data-id="element-63">
                📋 Planificación anual primaria y secundaria
              </h3>
              <p className="text-white/90 font-semibold text-lg mb-3" data-id="element-64">
                Para cada grado y año
              </p>
              <p className="text-white font-bold text-base sm:text-lg" data-id="element-65">
                No pensés más - Tene todo el año resuelto ✔
              </p>
            </div>

            <div className="space-y-8 max-w-xl mx-auto text-left" data-id="element-66">
              {/* Bloque 1 */}
              <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8" data-id="element-67">
                <h3 className="text-xl font-bold text-brand-pink mb-1 text-center" data-id="element-68">
                  🟣 BLOQUE 1 — BASES DEL INGLÉS
                </h3>
                <p className="text-brand-gray text-sm mb-5 text-center" data-id="element-69">
                  (primer ciclo nivel primario -A1)
                </p>
                <ul className="space-y-3" data-id="element-70">
                  {['Saludos y presentación personal', 'Emociones', 'Familia, roles y descripciones', 'Colores primarios y secundarios', 'Números de 1 al 1000', 'Animales y hábitat', 'Días, meses, estaciones del año y clima', 'Actividades con juegos y práctica oral'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium" data-id="element-71">
                      <span className="mr-3 text-green-500 text-lg" data-id="element-72">✔</span>
                      {item}
                    </li>)}
                </ul>
                <p className="mt-5 text-sm font-semibold text-brand-navy text-center" data-id="element-73">
                  💡 Ideal para empezar desde cero y enganchar desde el primer
                  día
                </p>
              </div>

              {/* Bloque 2 */}
              <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8" data-id="element-74">
                <h3 className="text-xl font-bold text-brand-pink mb-1 text-center" data-id="element-75">
                  🟣 BLOQUE 2 — ESTRUCTURA Y COMUNICACIÓN
                </h3>
                <p className="text-brand-gray text-sm mb-5 text-center" data-id="element-76">
                  (segundo ciclo nivel primario - A2)
                </p>
                <ul className="space-y-3" data-id="element-77">
                  {['Verb to be', 'Plurales', 'Artículos y preposiciones', 'Descripción de lugares', 'Rutinas diarias', 'Construcción de frases', 'Actividades y proyectos listos'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium" data-id="element-78">
                      <span className="mr-3 text-green-500 text-lg" data-id="element-79">✔</span>
                      {item}
                    </li>)}
                </ul>
                <p className="mt-5 text-sm font-semibold text-brand-navy text-center" data-id="element-80">
                  💡 Tus alumnos empiezan a entender y construir ideas
                </p>
              </div>

              {/* Bloque 3 */}
              <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8" data-id="element-81">
                <h3 className="text-xl font-bold text-brand-pink mb-1 text-center" data-id="element-82">
                  🟣 BLOQUE 3 — HABLAR CON CONFIANZA
                </h3>
                <p className="text-brand-gray text-sm mb-5 text-center" data-id="element-83">
                  (ciclo basico nivel secundario - B1)
                </p>
                <ul className="space-y-3" data-id="element-84">
                  {['Presente, pasado y futuro (simple, continuous, perfect, perfect continuous)', 'Verbos modales (can, could, may, might, must, should, will, would)', 'Conversaciones guiadas', 'Role plays listos'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium" data-id="element-85">
                      <span className="mr-3 text-green-500 text-lg" data-id="element-86">✔</span>
                      {item}
                    </li>)}
                </ul>
                <p className="mt-5 text-sm font-semibold text-brand-navy text-center" data-id="element-87">
                  💡 Más participación, más interacción real
                </p>
              </div>

              {/* Bloque 4 */}
              <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8" data-id="element-88">
                <h3 className="text-xl font-bold text-brand-pink mb-1 text-center" data-id="element-89">
                  🟣 BLOQUE 4 — INGLÉS EN LA VIDA REAL
                </h3>
                <p className="text-brand-gray text-sm mb-5 text-center" data-id="element-90">
                  (ciclo superior nivel secundario - B2)
                </p>
                <ul className="space-y-3" data-id="element-91">
                  {['Conditional (0, 1, 2)', 'Reported speech', 'Situaciones reales e imaginarias', 'Actividades aplicadas', 'Y otras estructuras más'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium" data-id="element-92">
                      <span className="mr-3 text-green-500 text-lg" data-id="element-93">✔</span>
                      {item}
                    </li>)}
                </ul>
                <p className="mt-5 text-sm font-semibold text-brand-navy text-center" data-id="element-94">
                  💡 Tus alumnos usan el idioma, no solo lo estudian
                </p>
              </div>
            </div>
          </FadeIn>
        </section>

        {/* 7. CTA */}
        <section className="text-center mb-12" data-id="element-95">
          <FadeIn data-id="element-96">
            <div className="max-w-md mx-auto mb-8" data-id="element-97">
              <img src="https://cdn.magicpatterns.com/uploads/6J9EmFwhUQTkRbxnGdj8bF/ChatGPT_Image_7_abr_2026,_08_31_22_p.m..png" alt="Megapack Teacher's Resource" className="w-full rounded-2xl" data-id="element-98" />
            </div>
            <Button data-id="element-99">👉 QUIERO RESOLVER MIS CLASES DE INGLÉS AHORA</Button>
          </FadeIn>
        </section>

        {/* 8. ANTES VS DESPUÉS */}
        <section className="mb-12" data-id="element-100">
          <FadeIn data-id="element-101">
            <div className="grid sm:grid-cols-2 gap-6" data-id="element-102">
              {/* Antes */}
              <div className="bg-white rounded-2xl p-6 sm:p-8 border-2 border-gray-200 text-center" data-id="element-103">
                <h3 className="text-xl font-bold text-brand-gray mb-6" data-id="element-104">
                  Antes del Megapack
                </h3>
                <ul className="space-y-4 text-left" data-id="element-105">
                  {['Improvisar cada clase', 'Buscar actividades en muchos lugares', 'Repetir siempre lo mismo', 'Perder horas planificando', 'Sentir que no te alcanza el tiempo'].map((item, i) => <li key={i} className="flex items-start text-brand-gray font-medium" data-id="element-106">
                      <span className="mr-3 font-bold text-brand-red text-xl" data-id="element-107">
                        •
                      </span>
                      {item}
                    </li>)}
                </ul>
              </div>

              {/* Después */}
              <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 border-2 border-brand-lightBlue text-center" data-id="element-108">
                <h3 className="text-xl font-bold text-brand-pink mb-6" data-id="element-109">
                  Después del Megapack
                </h3>
                <ul className="space-y-4 text-left" data-id="element-110">
                  {['Clases listas para todo el año', 'Actividades organizadas', 'Más participación en el aula', 'Clases dinámicas sin esfuerzo', 'Mucho menos tiempo preparando'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-bold" data-id="element-111">
                      <span className="mr-3 text-green-500 text-xl" data-id="element-112">✔</span>
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>
          </FadeIn>
        </section>

        {/* 9. BONUS SECTION */}
        <section className="text-center mb-12" data-id="element-113">
          <FadeIn data-id="element-114">
            <h2 className="text-2xl sm:text-3xl font-bold text-brand-navy mb-4" data-id="element-115">
              Además recibís estos BONUS
            </h2>
            <div className="inline-block bg-brand-pink text-white px-4 py-1 rounded-full text-sm font-bold mb-10 uppercase tracking-wide" data-id="element-116">
              🎁 GRATIS POR EL DÍA DE HOY
            </div>

            <div className="space-y-12 max-w-sm mx-auto" data-id="element-117">
              {/* Bonus 1 - All About Me */}
              <div data-id="element-118">
                <div className="mb-3" data-id="element-119">
                  <img src="https://cdn.magicpatterns.com/uploads/27ugRgbUzLCNJRSJfQK1gw/b2c35ba1-3fa9-4a8c-a2a5-992dcf377af2.png" alt="All About Me Bonus" className="w-full aspect-square object-contain rounded-xl" data-id="element-120" />
                </div>
                <h3 className="text-base sm:text-lg font-bold text-brand-pink mb-1" data-id="element-121">
                  BONUS 1 — All About Me
                </h3>
                <p className="text-brand-navy text-sm" data-id="element-122">
                  Para primeras semanas de clases.
                </p>
              </div>

              {/* Bonus 2 - FIFA World Cup */}
              <div data-id="element-123">
                <div className="mb-3" data-id="element-124">
                  <img src="https://cdn.magicpatterns.com/uploads/crSrWZ4YSFQrnPVbF964nV/23a1ece9-44be-47fc-a767-82b55c5df021.png" alt="FIFA World Cup Bonus" className="w-full aspect-square object-contain rounded-xl" data-id="element-125" />
                </div>
                <h3 className="text-base sm:text-lg font-bold text-brand-pink mb-1" data-id="element-126">
                  BONUS 2 — FIFA World Cup 2026
                </h3>
                <p className="text-brand-navy text-sm" data-id="element-127">
                  Actividades listas para trabajar un tema que engancha a todos
                  los alumnos.
                </p>
              </div>

              {/* Bonus 3 - Songs */}
              <div data-id="element-128">
                <div className="mb-3" data-id="element-129">
                  <img src="https://cdn.magicpatterns.com/uploads/f7RGCtUG1cTVU3Jy5iZ6SK/13bb7ca3-374b-4bd7-bea3-1c0f65d7a102.png" alt="Songs Bonus" className="w-full aspect-square object-contain rounded-xl" data-id="element-130" />
                </div>
                <h3 className="text-base sm:text-lg font-bold text-brand-pink mb-1" data-id="element-131">
                  BONUS 3 — Songs for English Class
                </h3>
                <p className="text-brand-navy text-sm" data-id="element-132">
                  Canciones con actividades listas para usar en clase.
                </p>
              </div>

              {/* Bonus 4 - Flashcards */}
              <div data-id="element-133">
                <div className="mb-3" data-id="element-134">
                  <img src="https://cdn.magicpatterns.com/uploads/iEntfU5GSkNfruiEqjhTej/927ee79f-f956-46ea-9e0b-d42032277b10.png" alt="Flashcards Bonus" className="w-full aspect-square object-contain rounded-xl" data-id="element-135" />
                </div>
                <h3 className="text-base sm:text-lg font-bold text-brand-pink mb-1" data-id="element-136">
                  BONUS 4 — Flashcards Ready to Use
                </h3>
                <p className="text-brand-navy text-sm" data-id="element-137">
                  Tarjetas listas para imprimir y usar directamente.
                </p>
              </div>

              {/* Bonus Especial - Halloween */}
              <div data-id="element-138">
                <div className="inline-block bg-brand-red text-white px-3 py-1 rounded-full text-xs font-bold mb-3 uppercase tracking-wide" data-id="element-139">
                  🎃 BONUS ESPECIAL DE REGALO
                </div>
                <div className="mb-3" data-id="element-140">
                  <img src="https://cdn.magicpatterns.com/uploads/t8FRbCtHPsZuqouaVWHshP/8484d9bf-bd1e-4bd3-9485-47d63a86bb6c.png" alt="Halloween Bonus" className="w-full aspect-square object-contain rounded-xl" data-id="element-141" />
                </div>
                <h3 className="text-base sm:text-lg font-bold text-brand-pink mb-1" data-id="element-142">
                  🎃 BONUS ESPECIAL — Halloween Activity Pack
                </h3>
                <p className="text-brand-navy text-sm" data-id="element-143">
                  Pack completo de actividades temáticas de Halloween:
                  vocabulario, juegos, worksheets y dinámicas listas para usar
                  en clase. Ideal para hacer de octubre un mes divertido y
                  educativo.
                </p>
              </div>
            </div>
          </FadeIn>
        </section>

        {/* PACK PREMIUM - English for Specific Purposes */}
        <section className="text-center mb-12" data-id="element-144">
          <FadeIn data-id="element-145">
            <div className="inline-block bg-brand-red text-white px-4 py-1 rounded-full text-sm font-bold mb-6 uppercase tracking-wide" data-id="element-146">
              ⭐ PACKS PREMIUM
            </div>

            <div className="max-w-sm mx-auto mb-8" data-id="element-147">
              <img src="https://cdn.magicpatterns.com/uploads/eN7fLbJoMX4hB73WpcaZiF/ChatGPT_Image_1_may_2026,_02_38_29_p.m._-_Editado.png" alt="English for Specific Purposes" className="w-full object-contain rounded-xl" data-id="element-148" />
            </div>

            <h2 className="text-2xl sm:text-3xl font-black text-brand-pink mb-3" data-id="element-149">
              ENGLISH FOR SPECIFIC PURPOSES
            </h2>
            <p className="text-base sm:text-lg text-brand-navy font-semibold mb-8 max-w-xl mx-auto" data-id="element-150">
              Aprendé el inglés que realmente necesitás para tu trabajo
            </p>

            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto text-left" data-id="element-151">
              <h3 className="text-lg font-bold text-brand-navy mb-2 text-center" data-id="element-152">
                👥 IDEAL PARA:
              </h3>
              <p className="text-brand-gray text-sm mb-5 text-center" data-id="element-153">
                🎓 Estudiantes y profesionales de:
              </p>
              <ul className="space-y-4" data-id="element-154">
                {[{
                area: 'Administración de empresas y PyMEs',
                desc: 'comunicación laboral + gestión'
              }, {
                area: 'Marketing',
                desc: 'clientes + presentaciones'
              }, {
                area: 'Recursos Humanos',
                desc: 'entrevistas + comunicación interna'
              }, {
                area: 'Turismo',
                desc: 'atención directa al cliente'
              }, {
                area: 'Salud',
                desc: 'trato con pacientes y equipo'
              }, {
                area: 'Comercio exterior',
                desc: 'operaciones internacionales reales'
              }].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium text-base" data-id="element-155">
                    <span className="mr-3 text-green-500 text-lg" data-id="element-156">✔</span>
                    <span data-id="element-157">
                      <span className="font-bold" data-id="element-158">{item.area}</span>{' '}
                      <span className="text-brand-gray" data-id="element-159">👉 {item.desc}</span>
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </section>

        {/* Inglés para Adultos */}
        <section className="text-center mb-12" data-id="element-160">
          <FadeIn data-id="element-161">
            <div className="max-w-sm mx-auto mb-8" data-id="element-162">
              <img src="https://cdn.magicpatterns.com/uploads/2qWmDEerAXJm77yTwGoWhg/345a4f15-4ee3-490b-9f50-ea85f910e184.png" alt="Inglés para Adultos" className="w-full object-contain rounded-xl" data-id="element-163" />
            </div>

            <h2 className="text-2xl sm:text-3xl font-black text-brand-pink mb-6" data-id="element-164">
              INGLÉS PARA ADULTOS
            </h2>

            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto text-left" data-id="element-165">
              <ul className="space-y-4" data-id="element-166">
                {['Inglés básico e intermedio aplicado a situaciones reales para adultos.', 'Actividades prácticas y visuales listas para usar', 'Enfoque en comunicación real: hablar, entender y responder con confianza'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium text-base" data-id="element-167">
                    <span className="mr-3 text-green-500 text-lg" data-id="element-168">✔</span>
                    {item}
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </section>

        {/* English for Travelers */}
        <section className="text-center mb-12" data-id="element-169">
          <FadeIn data-id="element-170">
            <div className="max-w-sm mx-auto mb-8" data-id="element-171">
              <img src="https://cdn.magicpatterns.com/uploads/naDHg6DzACqubKqfBF92XE/e86f32be-d4ae-4105-82b5-58cf72977ba4.png" alt="English for Travelers" className="w-full object-contain rounded-xl" data-id="element-172" />
            </div>

            <h2 className="text-2xl sm:text-3xl font-black text-brand-pink mb-6" data-id="element-173">
              ENGLISH FOR TRAVELERS
            </h2>

            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto text-left" data-id="element-174">
              <ul className="space-y-4" data-id="element-175">
                {['Inglés práctico para viajes y situaciones reales alrededor del mundo.', 'Actividades visuales y conversaciones listas para usar.', 'Enfoque en comunicación real: hablar, entender y viajar con más confianza.'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium text-base" data-id="element-176">
                    <span className="mr-3 text-green-500 text-lg" data-id="element-177">✔</span>
                    {item}
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </section>

        {/* Inglés Técnico Agro */}
        <section className="text-center mb-12" data-id="element-178">
          <FadeIn data-id="element-179">
            <div className="max-w-sm mx-auto mb-8" data-id="element-180">
              <img src="https://cdn.magicpatterns.com/uploads/cTF1fTR6Lex2JA142kZvyT/d0b1aeba-c187-494d-b90d-f2525b86500c.png" alt="Inglés Técnico Agro" className="w-full object-contain rounded-xl" data-id="element-181" />
            </div>

            <h2 className="text-2xl sm:text-3xl font-black text-brand-pink mb-6" data-id="element-182">
              INGLÉS TÉCNICO AGRO
            </h2>

            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto text-left" data-id="element-183">
              <p className="text-brand-navy font-medium text-base" data-id="element-184">
                Para docentes de secundaria técnica con orientación agropecuaria
                que buscan enseñar inglés de forma práctica, clara y aplicable
                al mundo real.
              </p>
            </div>
          </FadeIn>
        </section>

        {/* 10. ACCESO BLOCK */}
        <section className="text-center mb-12" data-id="element-185">
          <FadeIn data-id="element-186">
            <h2 className="text-2xl sm:text-3xl font-bold text-brand-navy mb-8" data-id="element-187">
              Accedé ahora al sistema completo listo para usar todo el año
            </h2>
            <Button onClick={() => document.getElementById('compra')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-188">
              👉 ACCEDE AL MEGAPACK HOY
            </Button>
          </FadeIn>
        </section>

        {/* 11. RESULTADO FINAL */}
        <section className="text-center mb-12" data-id="element-189">
          <FadeIn data-id="element-190">
            <h2 className="text-2xl sm:text-3xl font-bold text-brand-navy mb-8" data-id="element-191">
              El resultado para vos como docente
            </h2>

            <div className="bg-white border-2 border-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto mb-6 text-left" data-id="element-192">
              <ul className="space-y-4" data-id="element-193">
                {['Ahorrar horas de planificación', 'Tener clases listas en minutos', 'Lograr más participación', 'Sentirte más seguro al enseñar', 'Disfrutar más tus clases'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-bold text-lg" data-id="element-194">
                    <span className="mr-3 text-green-500 text-xl" data-id="element-195">✔</span>
                    {item}
                  </li>)}
              </ul>
            </div>
            <p className="font-bold text-brand-pink text-lg" data-id="element-196">
              Todo sin perder tiempo buscando material en internet.
            </p>
          </FadeIn>
        </section>

        {/* ACLARACIONES Y DETALLES */}
        <section className="mb-12" data-id="element-197">
          <div className="space-y-10 max-w-xl mx-auto" data-id="element-198">
            {/* 1. Aclaración */}
            <FadeIn data-id="element-199">
              <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8" data-id="element-200">
                <h3 className="text-xl font-bold text-brand-pink mb-4 text-center" data-id="element-201">
                  ⚠️ PRIMERA ACLARACIÓN (MUY IMPORTANTE)
                </h3>
                <p className="text-brand-navy font-bold text-lg text-center mb-4" data-id="element-202">
                  Esto no es un ebook.
                </p>
                <p className="text-brand-navy text-center mb-6" data-id="element-203">
                  Es un sistema de recursos docentes pensado para usar en clase.
                </p>
                <div className="space-y-2 mb-6" data-id="element-204">
                  <p className="text-brand-navy font-bold text-base" data-id="element-205">
                    👉 No venís a leer.
                  </p>
                  <p className="text-brand-navy font-bold text-base" data-id="element-206">
                    👉 Venís a resolver tus clases.
                  </p>
                </div>
                <ul className="space-y-3" data-id="element-207">
                  {['Material listo para usar', 'Actividades organizadas', 'Recursos pensados para aplicar directamente'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium" data-id="element-208">
                      <span className="mr-3 text-green-500 text-lg" data-id="element-209">✔</span>
                      {item}
                    </li>)}
                </ul>
              </div>
            </FadeIn>

            {/* 2. Cómo se usa */}
            <FadeIn data-id="element-210"></FadeIn>

            {/* 3. Flexibilidad */}
            <FadeIn data-id="element-211">
              <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8" data-id="element-212">
                <h3 className="text-xl font-bold text-brand-pink mb-4 text-center" data-id="element-213">
                  FLEXIBILIDAD TOTAL
                </h3>
                <p className="text-brand-navy text-center mb-6" data-id="element-214">
                  Podés usar el contenido como quieras:
                </p>
                <ul className="space-y-3 mb-6" data-id="element-215">
                  {['Imprimirlo', 'Usarlo en pantalla', 'Adaptarlo a tu clase', 'Repetirlo todas las veces que quieras'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium" data-id="element-216">
                      <span className="mr-3 text-green-500 text-lg" data-id="element-217">✔</span>
                      {item}
                    </li>)}
                </ul>
                <p className="text-brand-navy font-bold text-center text-lg" data-id="element-218">
                  👉 No hay límites. Es tuyo.
                </p>
              </div>
            </FadeIn>

            {/* 4. Ahorro de tiempo */}
            <FadeIn data-id="element-219"></FadeIn>

            {/* 5. Acceso de por vida */}
            <FadeIn data-id="element-220">
              <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8" data-id="element-221">
                <h3 className="text-xl font-bold text-brand-pink mb-4 text-center" data-id="element-222">
                  ACCESO DE POR VIDA + ACTUALIZACIONES
                </h3>
                <p className="text-brand-navy text-center mb-2 font-medium" data-id="element-223">
                  Esto es CLAVE:
                </p>
                <p className="text-brand-navy font-bold text-center text-lg mb-6" data-id="element-224">
                  💡 Tu acceso es de por vida.
                </p>
                <p className="text-brand-navy text-center mb-4" data-id="element-225">Y además:</p>
                <div className="space-y-3 mb-6" data-id="element-226">
                  {[{
                  emoji: '🔄',
                  text: 'El contenido se va actualizando constantemente'
                }, {
                  emoji: '➕',
                  text: 'Se agregan nuevas actividades'
                }, {
                  emoji: '🧠',
                  text: 'Se mejora en base a lo que los docentes necesitan'
                }].map((item, i) => <div key={i} className="flex items-start text-brand-navy font-medium" data-id="element-227">
                      <span className="mr-3 text-lg" data-id="element-228">{item.emoji}</span>
                      {item.text}
                    </div>)}
                </div>
                <p className="text-brand-navy font-bold text-center text-lg" data-id="element-229">
                  👉 Y vos seguís accediendo a todo sin pagar de nuevo.
                </p>
              </div>
            </FadeIn>
          </div>
        </section>
      </div>

      {/* 13. PRECIO SECTION - DARK BG */}
      <section id="compra" className="scroll-mt-10" data-id="element-230">
        <FadeIn data-id="element-231">
          <div className="bg-[#1a2744] py-16 px-4" data-id="element-232">
            <div className="max-w-3xl mx-auto text-center" data-id="element-233">
              <h2 className="text-2xl sm:text-3xl font-bold text-brand-pink mb-4" data-id="element-234">
                Accedé ahora al Megapack Teacher's Resource completo
              </h2>
              <p className="text-brand-pink font-bold text-lg sm:text-xl italic mt-6 mb-10 max-w-xl mx-auto" data-id="element-235">
                Crear todo este material por tu cuenta te llevaría meses
              </p>

              <div className="max-w-2xl mx-auto mb-10" data-id="element-236">
                <img src="https://cdn.magicpatterns.com/uploads/oxmBRkqPLYwHMKxY6Gmbds/Diseno_sin_titulo.png" alt="Megapack Teacher's Resource - Todo el material que necesitas" className="w-full" data-id="element-237" />
              </div>

              {/* Three plan cards */}
              <div className="grid md:grid-cols-3 gap-6 lg:gap-5 max-w-5xl mx-auto mb-10 items-stretch" data-id="element-238">
                {/* PLAN 1 - Esencial Primaria/Secundaria */}
                <div className="bg-[#0f1b33] rounded-3xl p-6 sm:p-7 flex flex-col text-left border border-white/10" data-id="element-239">
                  <div className="inline-block self-start bg-white/10 text-gray-200 px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider mb-4" data-id="element-240">
                    MEGAPACK COLE
                  </div>
                  <h3 className="text-white font-bold text-lg sm:text-xl mb-3 leading-tight" data-id="element-241">
                    Primaria y Secundaria
                  </h3>
                  <p className="text-gray-400 text-sm mb-6 leading-relaxed" data-id="element-242">
                    Niveles A1, A2, B1 y B2 + 5 BONUS de regalo
                  </p>
                  <ul className="space-y-2 mb-6 text-sm" data-id="element-243">
                    {['Más de 1000 actividades', 'Planificación anual completa', '5 BONUS incluye fifa world cup y halloween'].map((item, i) => <li key={i} className="flex items-start text-gray-200" data-id="element-244">
                        <span className="mr-2 text-green-400 text-base" data-id="element-245">✓</span>
                        {item}
                      </li>)}
                  </ul>
                  <div className="mt-auto" data-id="element-246">
                    <div className="text-3xl sm:text-4xl font-black text-white mb-1" data-id="element-247">
                      ARS $19.990
                    </div>
                    <p className="text-[11px] text-gray-400 mb-5" data-id="element-248">
                      Pago único · Acceso de por vida
                    </p>
                    <Button className="w-full" href="https://checkout.aula-mater.online/cart/66721883160621:1" data-id="element-249">
                      👉 LO QUIERO
                    </Button>
                  </div>
                </div>

                {/* PLAN 2 - Packs Premium */}
                <div className="bg-[#0f1b33] rounded-3xl p-6 sm:p-7 flex flex-col text-left border border-white/10" data-id="element-250">
                  <div className="inline-block self-start bg-white/10 text-gray-200 px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider mb-4" data-id="element-251">
                    MEGAPACK PREMIUN
                  </div>
                  <h3 className="text-white font-bold text-lg sm:text-xl mb-3 leading-tight" data-id="element-252">
                    Inglés Especializado
                  </h3>

                  <ul className="space-y-2 mb-6 text-sm" data-id="element-253">
                    {['English for Specific Purposes', 'Inglés para Adultos', 'English for Travelers', 'Inglés Técnico Agro'].map((item, i) => <li key={i} className="flex items-start text-gray-200" data-id="element-254">
                        <span className="mr-2 text-green-400 text-base" data-id="element-255">✓</span>
                        {item}
                      </li>)}
                  </ul>
                  <div className="mt-auto" data-id="element-256">
                    <div className="text-3xl sm:text-4xl font-black text-white mb-1" data-id="element-257">
                      ARS $21.990
                    </div>
                    <p className="text-[11px] text-gray-400 mb-5" data-id="element-258">
                      Pago único · Acceso de por vida
                    </p>
                    <Button className="w-full" href="https://checkout.aula-mater.online/cart/66733788856365:1" data-id="element-259">
                      👉 LO QUIERO
                    </Button>
                  </div>
                </div>

                {/* PLAN 3 - MEGAPACK COMPLETO (FEATURED) */}
                <div className="bg-gradient-to-b from-brand-pink to-[#c01471] rounded-3xl p-6 sm:p-7 flex flex-col text-left border-2 border-brand-pink relative shadow-2xl shadow-brand-pink/30 md:scale-105 md:-my-2" data-id="element-260">
                  <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-yellow-400 text-brand-navy px-4 py-1 rounded-full text-xs font-black uppercase tracking-wide whitespace-nowrap shadow-lg" data-id="element-261">
                    🔥 MÁS COMPLETO
                  </div>
                  <div className="inline-block self-start bg-white/20 text-white px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider mb-4 mt-2" data-id="element-262">
                    MEGAPACK COMPLETO
                  </div>
                  <h3 className="text-white font-black text-xl sm:text-2xl mb-3 leading-tight" data-id="element-263">
                    Megapack Teacher´s Resource
                  </h3>
                  <p className="text-white/90 text-sm mb-6 leading-relaxed" data-id="element-264">
                    TODO incluido: Primaria + Secundaria + Packs Premium + 5
                    Bonus
                  </p>
                  <ul className="space-y-2 mb-6 text-sm" data-id="element-265">
                    {['Planificación anual', '+1000 actividades primaria y secundaria', '5 BONUS de regalo', 'English for Specific Purposes', 'Inglés para Adultos', 'English for Travelers', 'Inglés Técnico Agro'].map((item, i) => <li key={i} className="flex items-start text-white font-medium" data-id="element-266">
                        <span className="mr-2 text-yellow-300 text-base font-bold" data-id="element-267">
                          ✓
                        </span>
                        {item}
                      </li>)}
                  </ul>
                  <div className="mt-auto" data-id="element-268">
                    <p className="text-white/70 line-through text-sm mb-1" data-id="element-269">
                      ARS $41.980
                    </p>
                    <div className="text-3xl sm:text-4xl font-black text-white mb-1" data-id="element-270">
                      ARS $29.990
                    </div>
                    <p className="text-[11px] text-yellow-200 font-bold mb-5" data-id="element-271">
                      ¡Ahorrás $11.990!
                    </p>
                    <a href="https://checkout.aula-mater.online/cart/44808100053037:1" className="inline-flex items-center justify-center w-full px-6 py-4 text-base sm:text-lg font-black text-brand-pink bg-white rounded-xl hover:bg-yellow-50 shadow-md hover:shadow-lg transition-all uppercase tracking-wide" data-id="element-272">
                      👉 LO QUIERO
                    </a>
                    <p className="mt-3 text-[10px] font-[500] text-white/80 text-center" data-id="element-273">
                      Tarjeta · Mercado Pago
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-[#0f1b33] rounded-3xl p-8 sm:p-10 max-w-xl mx-auto" data-id="element-274">
                <a href="https://wa.me/5491124676057?text=Hola%20vi%20el%20Megapack%20Teacher%C2%B4s%20Resource%20quiero%20realizar%20la%20compra%20por%20Whatsapp%20u%20obtener%20mas%20informacion" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 text-lg sm:text-xl font-bold text-white transition-colors duration-200 bg-brand-pink rounded-xl hover:bg-brand-darkPink shadow-md hover:shadow-lg mb-4" data-id="element-275">
                  <span className="text-center" data-id="element-276">
                    <svg className="w-5 h-5 inline-block align-middle mr-2" viewBox="0 0 24 24" fill="currentColor" data-id="element-277">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-278" />
                    </svg>
                    COMPRA POR WHATSAPP
                  </span>
                </a>

                <p className="text-[10px] font-[500] text-[#35C8C8] whitespace-nowrap" data-id="element-279">
                  Compra por Transferencia
                </p>

                <a href="https://drive.google.com/file/d/1m9UQVJIelAhk6xofKBFssuOpowKdla48/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="inline-block mt-6 font-semibold text-sm underline underline-offset-4 hover:text-white transition-colors text-[#F8EA21]" data-id="element-280">
                  📄 Ver muestra gratis
                </a>

                <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-white text-sm sm:text-base font-medium mt-8" data-id="element-281">
                  <div data-id="element-282">
                    <span className="text-green-400" data-id="element-283">✔</span> para todos los
                    niveles
                  </div>
                  <div data-id="element-284">
                    <span className="text-green-400" data-id="element-285">✔</span> acceso inmediato
                  </div>
                  <div data-id="element-286">
                    <span className="text-green-400" data-id="element-287">✔</span> descarga digital
                  </div>
                  <div data-id="element-288">
                    <span className="text-green-400" data-id="element-289">✔</span> material para
                    todo el año
                  </div>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </section>

      {/* COMPARACIÓN DIRECTA */}
      <section className="bg-[#1a2744] py-16 px-4" data-id="element-290">
        <FadeIn data-id="element-291"></FadeIn>
      </section>

      {/* CRÉDITO */}
      <div className="text-center py-8 px-4" data-id="element-292">
        <p className="text-brand-gray text-sm italic" data-id="element-293">
          Creado por{' '}
          <span className="font-bold text-brand-navy" data-id="element-294">Aula Mater</span>,
          proyecto educativo enfocado en facilitar el trabajo docente
        </p>
      </div>

      {/* 14. GARANTÍA */}
      <section className="text-center py-12 px-4" data-id="element-295">
        <FadeIn data-id="element-296">
          <div className="max-w-xl mx-auto" data-id="element-297">
            <img src="https://cdn.magicpatterns.com/uploads/c1WiiD5wweFWiSecTG8bGZ/pasted-image.jpg" alt="Garantía 7 días" className="w-28 h-28 mx-auto mb-4 object-contain" data-id="element-298" />
            <h2 className="text-xl sm:text-2xl font-bold text-brand-navy mb-4" data-id="element-299">
              Garantía de satisfacción de 7 días
            </h2>
            <div className="space-y-3 text-brand-navy" data-id="element-300">
              <p className="font-semibold" data-id="element-301">
                Queremos que estés 100% conforme con tu compra.
              </p>
              <p data-id="element-302">
                Probalo sin riesgo. Si no te resulta útil, podés pedir la
                devolución
              </p>
              <p className="font-bold text-brand-pink" data-id="element-303">
                Comprá con total tranquilidad: tu inversión está protegida.
              </p>
            </div>
          </div>
        </FadeIn>
      </section>

      {/* FOOTER */}
      <footer className="bg-black py-8 px-4" data-id="element-304">
        <div className="max-w-3xl mx-auto text-center space-y-4" data-id="element-305">
          <p className="text-white text-sm font-medium" data-id="element-306">
            © 2026 Aula Mater. Todos los derechos reservados.
          </p>
          <p className="text-gray-500 text-xs leading-relaxed max-w-lg mx-auto" data-id="element-307">
            Este sitio no es parte del sitio web de Facebook ni de Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca comercial de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}